<template>
  <div v-if="cajaAbierta?.isOpen" class="grid grid-flow-row gap-4">
    <div class="flex justify-center min-height-auto">
      <h1 class="text-3xl text-center font-extrabold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-6xl">
        Bienvenido
      </h1>
    </div>

    <div class="flex justify-center min-height-auto">
      <!-- Versión móvil: 2 columnas -->
      <div class="grid grid-cols-2 gap-1 w-full max-w-md md:hidden">
        <RouterLink to="/ListLavadosCaja">
          <button type="button"
            class="w-full inline-flex items-center justify-center px-2 py-2 lg:text-sm text-xs font-medium text-white bg-[#3edfa9] border border-gray-200 rounded-lg hover:bg-[#ffe068] focus:z-10 focus:ring-2 focus:ring-[#53ebb8] focus:text-[#53ebb8]">
            <svg class="w-3 h-3 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"
              fill="white">
              <path
                d="M160 0c17.7 0 32 14.3 32 32V67.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1c-.4-.1-.9-.1-1.3-.2l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11V32c0-17.7 14.3-32 32-32z" />
            </svg>
            Ventas Diarias
          </button>
        </RouterLink>

        <RouterLink to="/cajas">
          <button type="button"
            class="w-full inline-flex items-center justify-center px-2 py-2 lg:text-sm text-xs font-medium text-white bg-[#3edfa9] border border-gray-200 rounded-lg hover:bg-[#ffe068] focus:z-10 focus:ring-2 focus:ring-[#53ebb8] focus:text-[#53ebb8]">
            <svg class="w-3 h-3 me-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M7 1.75C7.41421 1.75 7.75 2.08579 7.75 2.5V3.26272C8.41203 3.24999 9.1414 3.24999 9.94358 3.25H14.0564C14.8586 3.24999 15.588 3.24999 16.25 3.26272V2.5C16.25 2.08579 16.5858 1.75 17 1.75C17.4142 1.75 17.75 2.08579 17.75 2.5V3.32709C18.0099 3.34691 18.2561 3.37182 18.489 3.40313C19.6614 3.56076 20.6104 3.89288 21.3588 4.64124C22.1071 5.38961 22.4392 6.33855 22.5969 7.51098C22.6472 7.88567 22.681 8.29459 22.7037 8.74007C22.7337 8.82106 22.75 8.90861 22.75 9C22.75 9.06932 22.7406 9.13644 22.723 9.20016C22.75 10.0021 22.75 10.9128 22.75 11.9436V14.0564C22.75 15.8942 22.75 17.3498 22.5969 18.489C22.4392 19.6614 22.1071 20.6104 21.3588 21.3588C20.6104 22.1071 19.6614 22.4392 18.489 22.5969C17.3498 22.75 15.8942 22.75 14.0564 22.75H9.94359C8.10583 22.75 6.65019 22.75 5.51098 22.5969C4.33856 22.4392 3.38961 22.1071 2.64124 21.3588C1.89288 20.6104 1.56076 19.6614 1.40314 18.489C1.24997 17.3498 1.24998 15.8942 1.25 14.0564V11.9436C1.24999 10.9127 1.24998 10.0021 1.27701 9.20017C1.25941 9.13645 1.25 9.06932 1.25 9C1.25 8.90862 1.26634 8.82105 1.29627 8.74006C1.31895 8.29458 1.35276 7.88566 1.40314 7.51098C1.56076 6.33856 1.89288 5.38961 2.64124 4.64124C3.38961 3.89288 4.33856 3.56076 5.51098 3.40313C5.7439 3.37182 5.99006 3.34691 6.25 3.32709V2.5C6.25 2.08579 6.58579 1.75 7 1.75ZM2.76309 9.75C2.75032 10.4027 2.75 11.146 2.75 12V14C2.75 15.9068 2.75159 17.2615 2.88976 18.2892C3.02502 19.2952 3.27869 19.8749 3.7019 20.2981C4.12511 20.7213 4.70476 20.975 5.71085 21.1102C6.73851 21.2484 8.09318 21.25 10 21.25H14C15.9068 21.25 17.2615 21.2484 18.2892 21.1102C19.2952 20.975 19.8749 20.7213 20.2981 20.2981C20.7213 19.8749 20.975 19.2952 21.1102 18.2892C21.2484 17.2615 21.25 15.9068 21.25 14V12C21.25 11.146 21.2497 10.4027 21.2369 9.75H2.76309ZM21.1683 8.25H2.83168C2.8477 8.06061 2.86685 7.88123 2.88976 7.71085C3.02502 6.70476 3.27869 6.12511 3.7019 5.7019C4.12511 5.27869 4.70476 5.02502 5.71085 4.88976C6.73851 4.75159 8.09318 4.75 10 4.75H14C15.9068 4.75 17.2615 4.75159 18.2892 4.88976C19.2952 5.02502 19.8749 5.27869 20.2981 5.7019C20.7213 6.12511 20.975 6.70476 21.1102 7.71085C21.1331 7.88123 21.1523 8.06061 21.1683 8.25ZM10.787 12.3071C11.0673 12.4232 11.25 12.6967 11.25 13V17C11.25 17.4142 10.9142 17.75 10.5 17.75C10.0858 17.75 9.75 17.4142 9.75 17V14.8107L9.53033 15.0303C9.23744 15.3232 8.76256 15.3232 8.46967 15.0303C8.17678 14.7374 8.17678 14.2626 8.46967 13.9697L9.96967 12.4697C10.1842 12.2552 10.5068 12.191 10.787 12.3071ZM14 13.75C13.8619 13.75 13.75 13.8619 13.75 14V16C13.75 16.1381 13.8619 16.25 14 16.25C14.1381 16.25 14.25 16.1381 14.25 16V14C14.25 13.8619 14.1381 13.75 14 13.75ZM12.25 14C12.25 13.0335 13.0335 12.25 14 12.25C14.9665 12.25 15.75 13.0335 15.75 14V16C15.75 16.9665 14.9665 17.75 14 17.75C13.0335 17.75 12.25 16.9665 12.25 16V14Z"
                fill="#ffffff"></path>
            </svg>
            Historial de Cajas
          </button>
        </RouterLink>

        <RouterLink to="/listingreso">
          <button type="button"
            class="w-full inline-flex items-center justify-center px-2 py-2 lg:text-sm text-xs font-medium text-white bg-[#3edfa9] border border-gray-200 rounded-lg hover:bg-[#ffe068] focus:z-10 focus:ring-2 focus:ring-[#53ebb8] focus:text-[#53ebb8]">
            <svg class="w-3 h-3 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"
              fill="white">
              <path
                d="M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z" />
            </svg>
            Ingresos diarios
          </button>
        </RouterLink>

        <RouterLink to="/listegreso">
          <button type="button"
            class="w-full inline-flex items-center justify-center px-2 py-2 lg:text-sm text-xs font-medium text-white bg-[#3edfa9] border border-gray-200 rounded-lg hover:bg-[#ffe068] focus:z-10 focus:ring-2 focus:ring-[#53ebb8] focus:text-[#53ebb8]">
            <svg class="w-3 h-3 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"
              fill="white">
              <path
                d="M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 416c0 17.7-14.3 32-32 32l-96 0z" />
            </svg>
            Egresos diarios
          </button>
        </RouterLink>
      </div>

      <!-- Versión escritorio: Diseño original en línea -->
      <div class="hidden md:inline-flex rounded-md shadow-sm" role="group">
        <RouterLink to="/ListLavadosCaja">
          <button type="button"
            class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-[#3edfa9] border border-gray-200 rounded-s-lg hover:bg-[#ffe068] focus:z-10 focus:ring-2 focus:ring-[#53ebb8] focus:text-[#53ebb8]">
            <svg class="w-3 h-3 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"
              fill="white">
              <path
                d="M160 0c17.7 0 32 14.3 32 32V67.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1c-.4-.1-.9-.1-1.3-.2l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11V32c0-17.7 14.3-32 32-32z" />
            </svg>
            Ventas Diarias
          </button>
        </RouterLink>

        <RouterLink to="/cajas">
          <button type="button"
            class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-[#3edfa9] border border-gray-200 hover:bg-[#ffe068] focus:z-10 focus:ring-2 focus:ring-[#53ebb8] focus:text-[#53ebb8]">
            <svg class="w-5 h-5 me-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M7 1.75C7.41421 1.75 7.75 2.08579 7.75 2.5V3.26272C8.41203 3.24999 9.1414 3.24999 9.94358 3.25H14.0564C14.8586 3.24999 15.588 3.24999 16.25 3.26272V2.5C16.25 2.08579 16.5858 1.75 17 1.75C17.4142 1.75 17.75 2.08579 17.75 2.5V3.32709C18.0099 3.34691 18.2561 3.37182 18.489 3.40313C19.6614 3.56076 20.6104 3.89288 21.3588 4.64124C22.1071 5.38961 22.4392 6.33855 22.5969 7.51098C22.6472 7.88567 22.681 8.29459 22.7037 8.74007C22.7337 8.82106 22.75 8.90861 22.75 9C22.75 9.06932 22.7406 9.13644 22.723 9.20016C22.75 10.0021 22.75 10.9128 22.75 11.9436V14.0564C22.75 15.8942 22.75 17.3498 22.5969 18.489C22.4392 19.6614 22.1071 20.6104 21.3588 21.3588C20.6104 22.1071 19.6614 22.4392 18.489 22.5969C17.3498 22.75 15.8942 22.75 14.0564 22.75H9.94359C8.10583 22.75 6.65019 22.75 5.51098 22.5969C4.33856 22.4392 3.38961 22.1071 2.64124 21.3588C1.89288 20.6104 1.56076 19.6614 1.40314 18.489C1.24997 17.3498 1.24998 15.8942 1.25 14.0564V11.9436C1.24999 10.9127 1.24998 10.0021 1.27701 9.20017C1.25941 9.13645 1.25 9.06932 1.25 9C1.25 8.90862 1.26634 8.82105 1.29627 8.74006C1.31895 8.29458 1.35276 7.88566 1.40314 7.51098C1.56076 6.33856 1.89288 5.38961 2.64124 4.64124C3.38961 3.89288 4.33856 3.56076 5.51098 3.40313C5.7439 3.37182 5.99006 3.34691 6.25 3.32709V2.5C6.25 2.08579 6.58579 1.75 7 1.75ZM2.76309 9.75C2.75032 10.4027 2.75 11.146 2.75 12V14C2.75 15.9068 2.75159 17.2615 2.88976 18.2892C3.02502 19.2952 3.27869 19.8749 3.7019 20.2981C4.12511 20.7213 4.70476 20.975 5.71085 21.1102C6.73851 21.2484 8.09318 21.25 10 21.25H14C15.9068 21.25 17.2615 21.2484 18.2892 21.1102C19.2952 20.975 19.8749 20.7213 20.2981 20.2981C20.7213 19.8749 20.975 19.2952 21.1102 18.2892C21.2484 17.2615 21.25 15.9068 21.25 14V12C21.25 11.146 21.2497 10.4027 21.2369 9.75H2.76309ZM21.1683 8.25H2.83168C2.8477 8.06061 2.86685 7.88123 2.88976 7.71085C3.02502 6.70476 3.27869 6.12511 3.7019 5.7019C4.12511 5.27869 4.70476 5.02502 5.71085 4.88976C6.73851 4.75159 8.09318 4.75 10 4.75H14C15.9068 4.75 17.2615 4.75159 18.2892 4.88976C19.2952 5.02502 19.8749 5.27869 20.2981 5.7019C20.7213 6.12511 20.975 6.70476 21.1102 7.71085C21.1331 7.88123 21.1523 8.06061 21.1683 8.25ZM10.787 12.3071C11.0673 12.4232 11.25 12.6967 11.25 13V17C11.25 17.4142 10.9142 17.75 10.5 17.75C10.0858 17.75 9.75 17.4142 9.75 17V14.8107L9.53033 15.0303C9.23744 15.3232 8.76256 15.3232 8.46967 15.0303C8.17678 14.7374 8.17678 14.2626 8.46967 13.9697L9.96967 12.4697C10.1842 12.2552 10.5068 12.191 10.787 12.3071ZM14 13.75C13.8619 13.75 13.75 13.8619 13.75 14V16C13.75 16.1381 13.8619 16.25 14 16.25C14.1381 16.25 14.25 16.1381 14.25 16V14C14.25 13.8619 14.1381 13.75 14 13.75ZM12.25 14C12.25 13.0335 13.0335 12.25 14 12.25C14.9665 12.25 15.75 13.0335 15.75 14V16C15.75 16.9665 14.9665 17.75 14 17.75C13.0335 17.75 12.25 16.9665 12.25 16V14Z"
                fill="#ffffff"></path>
            </svg>
            Historial de Cajas
          </button>
        </RouterLink>

        <RouterLink to="/listingreso">
          <button type="button"
            class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-[#3edfa9] border border-gray-200 hover:bg-[#ffe068] focus:z-10 focus:ring-2 focus:ring-[#53ebb8] focus:text-[#53ebb8]">
            <svg class="w-3 h-3 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"
              fill="white">
              <path
                d="M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z" />
            </svg>
            Ingresos diarios
          </button>
        </RouterLink>

        <RouterLink to="/listegreso">
          <button type="button"
            class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-[#3edfa9] border border-gray-200 rounded-e-lg hover:bg-[#ffe068] focus:z-10 focus:ring-2 focus:ring-[#53ebb8] focus:text-[#53ebb8]">
            <svg class="w-3 h-3 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"
              fill="white">
              <path
                d="M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 416c0 17.7-14.3 32-32 32l-96 0z" />
            </svg>
            Egresos diarios
          </button>
        </RouterLink>
      </div>
    </div>

    <div class="relative overflow-x-auto md:flex justify-center">
      <table class="w-full md:w-64 text-sm text-left rtl:text-right text-gray-500">
        <tbody>
          <tr class="bg-[#3edfa920]">
            <td class="border-r border-gray-400 px-2 py-1 font-bold w-56">
              Fecha:
            </td>
            <td class="px-2 py-1 w-56">
              {{ new Date().toLocaleDateString() }}
            </td>
          </tr>
          <tr>
            <td class="border-r border-gray-400 px-2 py-1 font-bold">
              Responsable:
            </td>
            <td class="px-2 py-1">{{ cajaAbierta.responsable }}</td>
          </tr>
          <tr class="bg-[#3edfa920]">
            <td class="border-r border-gray-400 px-2 py-1 font-bold">Turno:</td>
            <td class="px-2 py-1">{{ cajaAbierta.turno }}</td>
          </tr>
          <tr>
            <td class="border-r border-gray-400 px-2 py-1 font-bold">
              Inicial en Efectivo:
            </td>
            <td class="px-2 py-1">{{ formatImporte(cajaAbierta.montoInicial) ?? "0.00" }}</td>
          </tr>
          <tr class="bg-[#3edfa920]">
            <td class="border-r border-gray-400 px-2 py-1 font-bold">
              Cantidad de ventas en caja:
            </td>
            <td class="px-2 py-1">
              {{ cajaAbierta.cantidadLavados ?? 0 }}
            </td>
          </tr>
          <tr>
            <td class="border-r border-gray-400 px-2 py-1 font-bold">
              Abonado Efectivo:
            </td>
            <td class="px-2 py-1">
              {{ formatImporte(cajaAbierta.totalImporteLavados ?? 0) }}
            </td>
          </tr>
          <tr class="bg-[#3edfa920]">
            <td class="border-r border-gray-400 px-2 py-1 font-bold">
              Abonado Transf./tarjeta:
            </td>
            <td class="px-2 py-1">{{ formatImporte(cajaAbierta.totalOtrosPagos ?? 0) }}</td>
          </tr>
          <tr>
            <td class="border-r border-gray-400 px-2 py-1 font-bold">
              Pendientes Efectivo:
            </td>
            <td class="px-2 py-1">{{ formatImporte(cajaAbierta.pendientesEfectivo ?? 0) }}</td>
          </tr>
          <tr class="bg-[#3edfa920]">
            <td class="border-r border-gray-400 px-2 py-1 font-bold">
              Pendientes Transf./tarjeta:
            </td>
            <td class="px-2 py-1">{{ formatImporte(cajaAbierta.pendientesTransfTarjeta ?? 0) }}</td>
          </tr>
          <tr>
            <td class="border-r border-gray-400 px-2 py-1 font-bold">
              Total Ventas:
            </td>
            <td class="px-2 py-1">{{ formatImporte(cajaAbierta.totalVentas) ?? "0.00" }}</td>
          </tr>
          <tr class="bg-[#3edfa920]">
            <td class="border-r border-gray-400 px-2 py-1 font-bold">
              Ingresos en Efectivo:
            </td>
            <td class="px-2 py-1">
              {{ formatImporte(cajaAbierta.totalImporteIngresos) ?? "0.00" }}
            </td>
          </tr>
          <tr>
            <td class="border-r border-gray-400 px-2 py-1 font-bold">
              Ingresos Transf/Tarjeta:
            </td>
            <td class="px-2 py-1">
              {{ formatImporte(cajaAbierta.totalIngresosNoEfectivo) ?? "0.00" }}
            </td>
          </tr>
          <tr class="bg-[#3edfa920]">
            <td class="border-r border-gray-400 px-2 py-1 font-bold">
              Egresos en Efectivo:
            </td>
            <td class="px-2 py-1">
              {{ formatImporte(cajaAbierta.totalImporteEgresos) ?? "0.00" }}
            </td>
          </tr>
          <tr>
            <td class="border-r border-gray-400 px-2 py-1 font-bold">
              Egresos Transf./Tarjeta:
            </td>
            <td class="px-2 py-1">
              {{ formatImporte(cajaAbierta.totalEgresosNoEfectivo) ?? "0.00" }}
            </td>
          </tr>

          <tr class="bg-[#3edfa920]">
            <td class="border-r border-gray-400 px-2 py-1 font-bold">
              Efectivo en Caja:
            </td>
            <td class="px-2 py-1">
              {{ formatImporte(cajaAbierta.efectivoEnCaja) ?? "0.00" }}
            </td>
          </tr>

          <!-- Agregamos los nuevos balances -->
          <!-- <tr>
        <td class="border-r border-gray-400 px-2 py-1 font-bold">
          Balance Efectivo:
        </td>
        <td class="px-2 py-1">
          ${{ 
            (cajaAbierta.montoInicial ?? 0) + 
            (cajaAbierta.totalImporteLavados ?? 0) + 
            (cajaAbierta.totalImporteIngresos ?? 0) - 
            (cajaAbierta.totalImporteEgresos ?? 0) 
          }}
        </td>
      </tr> -->
          <tr>
            <td class="border-r border-gray-400 px-2 py-1 font-bold">
              Balance Transferencias/Tarjetas:
            </td>
            <td class="px-2 py-1">{{ formatImporte(cajaAbierta.totalOtrosPagos) ?? 0 }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="flex justify-center min-height-auto">
      <!-- Versión móvil: 2 columnas -->
      <div class="grid grid-cols-2 gap-2 w-full max-w-md md:hidden">
        <RouterLink to="/formlavado">
          <button type="button"
            class="w-full inline-flex items-center justify-center px-2 py-2 lg:text-sm text-xs font-medium text-white bg-[#3edfa9] border border-gray-200 rounded-lg hover:bg-[#ffe068] focus:z-10 focus:ring-2 focus:ring-[#53ebb8] focus:text-[#53ebb8]">
            <svg class="w-3 h-3 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"
              fill="white">
              <path
                d="M160 0c17.7 0 32 14.3 32 32V67.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1c-.4-.1-.9-.1-1.3-.2l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11V32c0-17.7 14.3-32 32-32z" />
            </svg>
            Agregar Venta
          </button>
        </RouterLink>

        <RouterLink to="/formingreso">
          <button type="button"
            class="w-full inline-flex items-center justify-center px-2 py-2 lg:text-sm text-xs font-medium text-white bg-[#3edfa9] border border-gray-200 rounded-lg hover:bg-[#ffe068] focus:z-10 focus:ring-2 focus:ring-[#53ebb8] focus:text-[#53ebb8]">
            <svg class="w-3 h-3 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"
              fill="white">
              <path
                d="M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z" />
            </svg>
            Agregar Ingreso
          </button>
        </RouterLink>

        <RouterLink to="/formegreso">
          <button type="button"
            class="w-full inline-flex items-center justify-center px-2 py-2 lg:text-sm text-xs font-medium text-white bg-[#3edfa9] border border-gray-200 rounded-lg hover:bg-[#ffe068] focus:z-10 focus:ring-2 focus:ring-[#53ebb8] focus:text-[#53ebb8]">
            <svg class="w-3 h-3 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"
              fill="white">
              <path
                d="M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 416c0 17.7-14.3 32-32 32l-96 0z" />
            </svg>
            Agregar egreso
          </button>
        </RouterLink>

        <RouterLink to="/cerrarcaja">
          <button type="button"
            class="w-full inline-flex items-center justify-center px-2 py-2 lg:text-sm text-xs font-medium text-white bg-red-600 border border-gray-200 rounded-lg hover:bg-red-700 focus:z-10 focus:ring-2 focus:ring-red-300 focus:text-red-100">
            <svg class="w-3 h-3 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"
              fill="white">
              <path
                d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
            </svg>
            Cerrar caja
          </button>
        </RouterLink>
      </div>

      <!-- Versión escritorio: Diseño original en línea -->
      <div class="hidden md:inline-flex rounded-md shadow-sm" role="group">
        <RouterLink to="/formlavado">
          <button type="button"
            class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-[#3edfa9] border border-gray-200 rounded-s-lg hover:bg-[#ffe068] focus:z-10 focus:ring-2 focus:ring-[#53ebb8] focus:text-[#53ebb8]">
            <svg class="w-3 h-3 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"
              fill="white">
              <path
                d="M160 0c17.7 0 32 14.3 32 32V67.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1c-.4-.1-.9-.1-1.3-.2l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11V32c0-17.7 14.3-32 32-32z" />
            </svg>
            Agregar Venta
          </button>
        </RouterLink>

        <RouterLink to="/formingreso">
          <button type="button"
            class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-[#3edfa9] border border-gray-200 hover:bg-[#ffe068] focus:z-10 focus:ring-2 focus:ring-[#53ebb8] focus:text-[#53ebb8]">
            <svg class="w-3 h-3 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"
              fill="white">
              <path
                d="M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z" />
            </svg>
            Agregar Ingreso
          </button>
        </RouterLink>

        <RouterLink to="/formegreso">
          <button type="button"
            class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-[#3edfa9] border border-gray-200 hover:bg-[#ffe068] focus:z-10 focus:ring-2 focus:ring-[#53ebb8] focus:text-[#53ebb8]">
            <svg class="w-3 h-3 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"
              fill="white">
              <path
                d="M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 416c0 17.7-14.3 32-32 32l-96 0z" />
            </svg>
            Agregar egreso
          </button>
        </RouterLink>

        <RouterLink to="/cerrarcaja">
          <button type="button"
            class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-red-600 border border-gray-200 rounded-e-lg hover:bg-red-700 focus:z-10 focus:ring-2 focus:ring-red-300 focus:text-red-100">
            <svg class="w-3 h-3 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"
              fill="white">
              <path
                d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
            </svg>
            Cerrar caja
          </button>
        </RouterLink>
      </div>
    </div>
  </div>
  <!-- <div class="relative overflow-x-auto md:flex justify-center mt-4">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <div class="bg-white p-4 rounded-lg shadow-md">
        <h3 class="text-lg font-semibold text-center mb-2">Ventas Diarias</h3>
        <canvas id="ventasChart"></canvas>
      </div>
      <div class="bg-white p-4 rounded-lg shadow-md">
        <h3 class="text-lg font-semibold text-center mb-2">Ingresos vs Egresos</h3>
        <canvas id="ingresosEgresosChart"></canvas>
      </div>
    </div>
  </div> -->
</template>

<script>
import { Chart } from "chart.js";

import cajaService from "../../composables/api/cajaService.js";
import { reactive, onMounted, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { store } from "../../store.js"; // Importa el store
import authService from "../../composables/api/authService.js";
import { initFlowbite } from "flowbite";

export default {
  name: "caja",
  setup() {
    let cajaAbierta = ref({});
    const router = useRouter();
    const route = useRoute();

    const formatImporte = (importe) => {
      return importe.toLocaleString('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    onMounted(async () => {
      cajaAbierta.value = await cajaService.getCajaAbierta();
      const currentUser = await authService.getCurrentUser();
      store.role = currentUser.roles[0].toLowerCase();
      if (store.role == "owner") {
        router.push("/owner/usuariosadmin");
        return;
      }
      if (cajaAbierta.value == undefined) {
        router.push("/abrircaja");
      }
      cajaService.getCajas();

      initFlowbite(); // Inicializa componente de Flowbite
      renderCharts();
    });

    const renderCharts = () => {
      // Ventas Diarias Chart
      // new Chart(document.getElementById("ventasChart").getContext("2d"), {
      //   type: "bar",
      //   data: {
      //     labels: ["Efectivo", "Transf/Tarjeta"],
      //     datasets: [
      //       {
      //         label: "Ventas",
      //         data: [
      //           cajaAbierta.value.totalImporteLavados ?? 0,
      //           cajaAbierta.value.totalOtrosPagos ?? 0,
      //         ],
      //         backgroundColor: ["#3edfa9", "#53ebb8"],
      //       },
      //     ],
      //   },
      //   options: {
      //     responsive: true,
      //     scales: {
      //       y: {
      //         beginAtZero: true,
      //       },
      //     },
      //   },
      // });
      // // Ingresos vs Egresos Chart
      // new Chart(document.getElementById("ingresosEgresosChart").getContext("2d"), {
      //   type: "line",
      //   data: {
      //     labels: ["Ingresos Efectivo", "Egresos Efectivo", "Ingresos Transf/Tarjeta", "Egresos Transf/Tarjeta"],
      //     datasets: [
      //       {
      //         label: "Efectivo",
      //         data: [
      //           cajaAbierta.value.totalImporteIngresos ?? 0,
      //           cajaAbierta.value.totalImporteEgresos ?? 0,
      //         ],
      //         borderColor: "#3edfa9",
      //         fill: false,
      //       },
      //       {
      //         label: "Transf/Tarjeta",
      //         data: [
      //           cajaAbierta.value.totalIngresosNoEfectivo ?? 0,
      //           cajaAbierta.value.totalEgresosNoEfectivo ?? 0,
      //         ],
      //         borderColor: "#53ebb8",
      //         fill: false,
      //       },
      //     ],
      //   },
      //   options: {
      //     responsive: true,
      //     scales: {
      //       y: {
      //         beginAtZero: true,
      //       },
      //     },
      //   },
      // });
    };

    return {
      cajaAbierta,
      renderCharts,
      formatImporte
    };
  },
};
</script>

<style></style>
